<template>
    <div>
        <agent-map v-if="isAgentAdminMap"  />
        <agent-config v-else />
    </div>
</template>

<script>
import agentConfig from "@/views/agent-management/components/agent.vue";
import agentMap from "@/views/dashboard/agent-home.vue";
import { getLogionUserInfo } from "@/utils/auth"; // 验权
import { AGENT_LOGIN_ROLE_VAL } from "@/utils/enumUtile";

export default {
    name: "agentManagementList",
    data() {
        return {
            isAgentLogin: null,
            isShowMap: null,
            isAgentAdminMap: false,
        };
    },
    created() {
        this.isAgentLogin = getLogionUserInfo().isAgentLogin;
        this.isShowMap = getLogionUserInfo()?.teamLogo == 0; // 0 黄丽账号， 1.显示3D地图
        this.isAgentAdminMap = this.isShowMap && this.isAgentLogin === AGENT_LOGIN_ROLE_VAL.AGENT_ADMIN_MAP;
    },

    methods: {
        /**
         * 获取代理商配置列表
         */
        onAgentConfig() {
            getAgentConfig().then((res) => {
                this.agentConfigList = res.data;
            });
        },

        getList() {
            this.listLoading = false;

            getAgentList(this.listQuery).then((res) => {
                this.list = res.data.entitys;
                this.total = res.data.totalCount;
                console.log("分润list-1", res, this.list);
                this.listLoading = false;
            });
        },
        handleFilter() {
            this.listQuery.page = 1;
            this.getList();
        },
        handleSizeChange(val) {
            this.listQuery.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },
    },
    components: {
        agentConfig,
        agentMap,
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-image {
    width: 40px;
    height: 40px;
}
</style>
